import { render, staticRenderFns } from "./updateDialog.vue?vue&type=template&id=b65861be&scoped=true&lang=pug&"
import script from "./updateDialog.vue?vue&type=script&lang=js&"
export * from "./updateDialog.vue?vue&type=script&lang=js&"
import style0 from "./updateDialog.vue?vue&type=style&index=0&id=b65861be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65861be",
  null
  
)

export default component.exports